import { Components, Theme } from '@mui/material';

const makeMuiSvgIcon = (theme: Theme): Components['MuiSvgIcon'] => ({
  styleOverrides: { colorPrimary: { color: theme.palette.primary.main } },
});

export default makeMuiSvgIcon;
